import {
  IClearMyPeerQuestionnaireAction,
  IGetMyPeerQuestionnaireAction,
  IGetMyPeerQuestionnaireActionFulfilled,
  IGetMyPeerQuestionnaireActionRejected,
  IMyPeerQuestionnaireReduxState,
  IRefetchMyPeerQuestionnaireAction
} from "../../types";

const initialState: IMyPeerQuestionnaireReduxState = {
  completed: true,
  pending: false,
  questionnaire: null,
  rejected: false
};

type Action =
  | IGetMyPeerQuestionnaireAction
  | IGetMyPeerQuestionnaireActionFulfilled
  | IGetMyPeerQuestionnaireActionRejected
  | IClearMyPeerQuestionnaireAction
  | IRefetchMyPeerQuestionnaireAction;

export default (state = initialState, action: Action): IMyPeerQuestionnaireReduxState => {
  switch (action.type) {
    case "CLEAR_MY_PEER_QUESTIONNAIRE":
      return {
        ...state,
        completed: false,
        pending: false,
        questionnaire: null,
        rejected: false
      };
    case "GET_MY_PEER_QUESTIONNAIRE_REJECTED":
      return {
        ...state,
        completed: true,
        pending: false,
        questionnaire: null,
        rejected: true
      };
    case "GET_MY_PEER_QUESTIONNAIRE":
      return {
        ...state,
        completed: false,
        pending: true,
        questionnaire: null,
        rejected: false
      };
    case "GET_MY_PEER_QUESTIONNAIRE_FULFILLED":
      return {
        ...state,
        completed: true,
        pending: false,
        questionnaire: action.payload,
        rejected: false
      };
    default:
      return state;
  }
};
